import Icon, { IIconProps } from 'components/icons';

type IconName = IIconProps['icon'];

// Lab, Skill Dive Lab and Skill Dive Collection share one glyph — the exported
// Figma assets for all three are identical; the label tells them apart.
const CONTENT_TYPE_ICONS: Record<string, IconName | undefined> = {
  course: 'ContentTagCourse',
  'learning-path': 'ContentTagLearningPath',
  'learning-path-with-cert': 'ContentTagLearningPath',
  lab: 'ContentTagLab',
  'ctf-lab': 'ContentTagLab',
  collection: 'ContentTagLab',
  video: 'ContentTagVideo',
  link: 'ContentTagLink',
};

export const getContentTypeIconName = (value: string): IconName | undefined =>
  CONTENT_TYPE_ICONS[value];

export const hasContentTypeIcon = (value: string): boolean =>
  Boolean(getContentTypeIconName(value));

interface IContentTypeIconProps {
  value: string;
  size?: IIconProps['size'];
}

const ContentTypeIcon = ({
  value,
  size = 'smaller',
}: IContentTypeIconProps): JSX.Element | null => {
  const icon = getContentTypeIconName(value);

  if (!icon) return null;

  return <Icon icon={icon} size={size} aria-hidden focusable={false} />;
};

export default ContentTypeIcon;
